'use client'

import { useEffect, useState, useCallback, useRef } from 'react'
import { NextPage } from 'next'
import { isDev } from 'app/general'
import { App } from '@capacitor/app';
import { updateToken } from 'actions/user';
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'
import { PluginListenerHandle } from '@capacitor/core/types/definitions';
import { isUrlAuth, isUrlAvailableForNonUsers } from 'helpers/general';
import { usePathname, useRouter } from 'next/navigation';
import { getMyActivity } from 'actions/activity';
import { getLatestEvents } from 'actions/event';
import { getLatestPosts } from 'actions/post';
import { getLatestProfiles } from 'actions/profile';
import { setLastGeneralRefresh } from 'actions/general';

interface Props {
  children: JSX.Element | JSX.Element[]
}

const IsAppForeground: NextPage<Props> = ({ children }) => {
  const user = useAppSelector((state) => state.userReducer.user);
  const router = useRouter();
  const [listener, setListener] = useState<PluginListenerHandle | null>(null);
  const dispatch = useAppDispatch()
  const pathname = usePathname() || ""
  const lastGeneralRefresh = useAppSelector((state) => state.mainReducer.lastGeneralRefresh)
  const myProfile = useAppSelector((state) => state.profileReducer.profile)
  const refreshRef = useRef<() => Promise<void>>();


  const refresh = useCallback(async () => {

    if (!user) {
      if (isUrlAvailableForNonUsers(pathname) || isUrlAuth(pathname)) {
        return;
      } else {
        router.push("/onboarding");
        return;
      }
    }

    try {
      
      const diff = Date.now() - lastGeneralRefresh;
      if (diff > 10000) {
        console.log("Refreshing token")
        await dispatch(updateToken(true));
        dispatch(getLatestPosts("", myProfile?.country, myProfile?.city, true))
        dispatch(getLatestProfiles(myProfile?.country, myProfile?.city, 20, true))
        dispatch(getLatestEvents(myProfile?.country, myProfile?.city, "", 30, true))
        dispatch(getMyActivity())
        dispatch(setLastGeneralRefresh(Date.now()));
      }

    } catch (error) {
      isDev && console.error("Error updating token", error);
    }
  }, [user, pathname, router, lastGeneralRefresh, myProfile, dispatch]);

  // Update the ref whenever refresh changes
  refreshRef.current = refresh;

  useEffect(() => {
    if (!listener) {
      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive && refreshRef.current) {
          refreshRef.current();
        }
      }).then(setListener);
    }

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, [listener]);

  return children
}
export default IsAppForeground
